<template>
  <v-autocomplete
    :disabled="disabled"
    v-model="inputVal"
    :label="$t('officer_config.faculty')"
    :items="faculties"
    :item-value="(item) => item.FACULTY_ID"
    :item-text="(item) => objectTranslator(item, 'FACULTY_NAME')"
    :rules="requiredRules"
    outlined
    dense
  ></v-autocomplete>
</template>

<script>
import FacultyProvider from "@/services/faculty.provider";
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";

const facultyService = new FacultyProvider();

export default {
  name: "SelectFaculty",
  props: {
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      faculties: null,
      requiredRules: [validator.required],
    };
  },
  methods: {
    objectTranslator,
    async fetch_faculty() {
      const faculties = await facultyService.getFaculties();
      this.faculties = faculties;
    },
  },
  created() {
    this.fetch_faculty();
  },
};
</script>